import { useEffect } from 'react'
import { useFormikContext } from 'formik'

const ScrollToError = () => {
  const formik = useFormikContext()
  const submitting = formik?.isSubmitting

  useEffect(() => {
    const el = document.querySelector('.error-label')

    if(el && el.parentElement){
      el.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.focus({ preventScroll: true })
    }
  }, [submitting])

  return null
}

export default ScrollToError